import {
	webapi,
	registerPreferenceCallbacks
} from 'ps-gui';

import transit from 'transit-immutable-js';

let preferences = {};

async function loadPreferences() {
	let prefs = await webapi.execute('/api/proc/api_user/getPreferences');
	preferences = {};
	prefs.forEach(pref => {
		const key = pref.key;
		let value = transit.fromJSON(pref.value);
		preferences[key] = value;
	});
	console.log('loaded preferences = ', preferences);
}

async function savePreferences(keys) {
	let pars = keys.map(key => {
		let value = preferences[key];
		if (value === undefined) {
			return null;
		}
		return {
			key,
			value: transit.toJSON(value)
		};
	}).filter(Boolean);
	webapi.execute('/api/proc/api_user/setPreferences', pars, null, true);
}

export async function initializePreferences() {
	await loadPreferences();
	registerPreferenceCallbacks({
		getPreference: function(key) {
			return preferences[key];
		},
		setPreference: function(key, value) {
			preferences[key] = value;
			savePreferences([key]);
		}
	});
}
